// 契約情報入力内容変更時、保存確認のダイアログを表示するまでのインターバル（分指定）
export const NOFITY_SAVING_INTERVAL = parseInt(process.env.REACT_APP_NOFITY_SAVING_INTEVAL) * 60 * 1000;

// FRK書式：仲介業者が三菱不動産会社を判定する為の仲介業者会社ID
export const OPERATOR_AGENCY_MUFG = process.env.REACT_APP_OPERATOR_AGENCY_MUFG.split(',');
